var flashcard_settings = function (settings) {

    var str = '<table class="table chapter-table"><tr><th>&nbsp;</th><th>Chapter</th><th>Number</th><th>Available</th></tr>' +
        '<tr>' +
        '<td><input type="checkbox" name="all_chapters" id="all_chapters" value="on"/></td>' +
        '<td><label for="all_chapters">All Chapters</label></td>' +
        '<td><input type="text" name="all_chapters_num" class="chapter-count" id="all_chapters_num" value="'+ settings.all_chapter_count +'" numMax="\'+ settings.all_chapter_count +\'"/></td>' +
        '<td>'+settings.all_chapter_count+'</td>' +
        '</tr>' ;
    for ( var i = 0; i < settings.chapters.length ; i++ ) {
        var chapter = settings.chapters[i];
        // var chapter_max = 100;
        // if (parseInt(chapter.count) < 100 ) {
        //     chapter_max = chapter.count;
        // }
        str += '<tr>' +
            '<td><input type="checkbox" class="select_chapter" id="chapter_'+ chapter.id +'" value="'+ chapter.id +'" /></td>' +
            '<td><label for="chapter_'+ chapter.id +'">'+ chapter.name+'</label></td>' +
            '<td><input type="text" class="chapter-count" id="num_'+ chapter.id +'" value="'+ chapter.count +'" numMax="'+ chapter.count+'"></td>' +
            '<td>'+ chapter.count +'</td>' +
            '</tr>';
    }
    str +='</table>';
    var table = $.parseHTML(str);

    // check all will remove other chapters
    $(table).find('#all_chapters').on('click',function() {
        if ($(this).prop('checked')== true) {
            $('.select_chapter').prop('checked',false);
        }
    });

    // check on any other will remove check all

    $(table).find('.select_chapter').on('click',function() {
        if ($(this).prop('checked') == true ) {
            $('#all_chapters').prop('checked',false);
        }
    });

    $(table).find('.chapter-count').on('change',function() {
        var val = parseInt($(this).val());
        var max = parseInt($(this).attr('numMax'));
        if ( parseInt($(this).val()) > parseInt($(this).attr('numMax')) ) {
            $(this).val( $(this).attr('numMax'));
        }
    });
    $(table).find('#all_chapters').on('change',function() {
        var val = parseInt($(this).val());
        var max = parseInt($(this).attr('numMax'));
        if ( parseInt($(this).val()) > parseInt($(this).attr('numMax')) ) {
            $(this).val( $(this).attr('numMax'));
        }
    });
    return table;
}

module.exports = flashcard_settings;


//////////////////
// WEBPACK FOOTER
// ./src/flashcard_settings.js
// module id = 223
// module chunks = 0